import { CaretDownFilled } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Cascader as Cascaded,
  Button,
  Popover,
  notification,
} from 'antd'
import form from 'antd/lib/form'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DrugImg from '../../commoditySave/image/drug.png'
import { RootDispatch } from '../../../app/store'
import styles from './storeSearchDetail.module.css'
import { getMaterialsName, Materiales } from '../../../models/commodity'
import { getCommonCodeCompletions, selectCommonCodes } from '../../completion/completionSlice'
import { CommonCodeCategory } from '../../../models/commoncode'
import { BillingCategoryName, InvoiceBillingCategories } from '../../../models/billingCategory'
import { RecipeItemFieldInput } from '../../treatment/editor/components/RecipeItemFieldInput'
import { getOtcCategoryName, OtcCategories } from '../../../models/Otccategory'
import { selectTenantCategory } from '../../../app/applicationSlice'
import { detailStoresearch, selectDetail, setDetail, updataStoreseachAsync } from '../storesearchSlice'
import { useLocation } from 'react-router-dom'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'

const { Option } = Select

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 22 },
}

export const StoreSearchDetailForm = (props: {
  selectId?: any
  flag?: boolean
}): ReactElement => {

  const location: any = useLocation()

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const detail: any = useSelector(selectDetail)

  const selectId = location?.state?.selectId

  const materialsCategory = location?.state?.materialsCategory

  const tenantCategory = useSelector(selectTenantCategory)  // 17 校医务室 不展示进价售价

  const YPdata = useSelector(selectCommonCodes(CommonCodeCategory.Durg))  // 药品分类

  const [ZYCYPshow, setZYCYPshow] = useState(false) //是否中药材/饮片

  const [selectJL, setSelectJL] = useState<any>('0')

  const [doseUnitData, setDoseUnitData] = useState<any>() //成分含量单位

  const [isSubmitLoading, setIsSubmitLoading] = useState<any>(false) //提交loading

  const [splitTag, setSplitTag] = useState(false) //是否拆零

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 6rem',
    },
  }

  useEffect(() => {
    setZYCYPshow(false)
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Durg, '')) // 药品分类
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Unit, '')) // 单位
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Frequency, '')) // 频次
    if (selectId) {
      dispatch(setDetail({}))
      dispatch(detailStoresearch(selectId))
    }
  }, [])

  useEffect(() => {
    if (JSON.stringify(detail) != '{}') {
      console.log(detail,detail?.drugCategory,"detaildetaildetail")
      form.setFieldsValue({
        ...detail,
        tax: detail?.tax > 0 ? detail?.tax : '', //项目税率
        noTraceCodeFlag: detail?.noTraceCodeFlag < 0 ? '0' : (detail?.noTraceCodeFlag)?.toString() || '0', //药品标识码
        retailPrice: detail.retailPrice > 0 ? detail.retailPrice?.toFixed(5) : '',
        stockPrice: detail.unitPrice > 0 ? detail.unitPrice?.toFixed(5) : '',
        splitPrice: detail.splitPrice > 0 ? detail.splitPrice?.toFixed(2) : '',
        materialsCategory: materialsCategory,
        productDate: moment(detail.productDate).format(DateTimeFormatSimple),
        deadline: moment(detail.deadline).format(DateTimeFormatSimple),
        capacity: detail.capacity > 0 ? detail.capacity : '',
        components: detail.components > 0 ? detail.components : '',
        minPackNums: detail.minPackNums > 0 ? detail.minPackNums : '',
      })
      if (detail?.capacity && detail?.capacityUnit && detail?.components && detail?.componentsUnit) {
        setSelectJL('1')
      }else{
        setSelectJL('0')
      }
      if (detail?.drugCategory === '中药材/饮片') {
        setZYCYPshow(true) //中药材
      }else{
        setZYCYPshow(false) //药品
      }
      setSplitTag(detail.splitTag == 1 ? true : false)
    }
  }, [detail])

  return (
    <div className={styles.saveform}>
      <Form
        className={styles.formContent}
        {...layout}
        form={form}
        name='control-hooks'
        autoComplete='off'
        layout='vertical'
        onFinish={(fs) => {
          const endTime = fs.deadline ? moment(fs.deadline).endOf('day').format(DateTimeFormat) : ''
          const productTime = fs.productDate ? moment(fs.productDate).endOf('day').format(DateTimeFormat) : ''
          dispatch(
            updataStoreseachAsync({
              productDate: productTime,
              deadline: endTime,
              shelfNo: fs.shelfNo,
              plateNo: fs.plateNo,
              id: selectId,
            })
          )
            .then(unwrapResult)
            .then((res) => {
              history.go(-1)
              notification.success({
                message: '操作成功',
                duration: 3,
              })
            })
        }}
      >
        {/* 中心内容 */}
        <Row className={styles.centerContent}>
          {/* 左侧内容 */}
          <Col span={tenantCategory == 17 ? 24 : 15} className={styles.leftContent}>
            <div className={styles.titleText}> 商品基本信息</div>
            {materialsCategory == 0 ?
              <Row>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='no'
                    label='商品编码'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='name'
                    label='通用名'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='genericName'
                    label='商品名'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label='类别'
                    {...firstColumnLayout}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={9}>
                        <Form.Item name='materialsCategory' >
                          <Select placeholder='' allowClear disabled>
                            {Materiales.map((v) => (
                              <Option value={v} key={v}>
                                {getMaterialsName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={15}>
                        <Form.Item name='drugCategory'>
                          <Select
                            disabled
                          >
                            {YPdata.map((s) => (
                              <Select.Option key={s.name} value={s.name}>
                                {s.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='billingCategory'
                    label='开票项目'
                  >
                    <Select
                      placeholder=''
                      allowClear={false}
                      disabled
                    >
                      {InvoiceBillingCategories.map((v) => {
                        return (
                          <Option value={v} key={v}>
                            {BillingCategoryName(v)}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='approvalNumber'
                    label='批准文号'
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='doseCategory'
                    label='剂型'
                  >
                    <RecipeItemFieldInput
                      clearDataFlag={false}
                      field={'doseCategory'}
                      disabled={true}
                      noSize={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='tenantSupplierName'
                    label='生产厂家'
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='lstdLicHolder' label='上市许可持有人'>
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                {/* 中药材/饮片不展示剂量 */}
                {!ZYCYPshow ?
                  <Col span={8}>
                    <Col className={styles.jlTitle}>
                      <span
                      >{selectJL == '0' ? '剂量 (成分含量)' : '剂量 (容量：成分含量)'}</span>
                    </Col>
                    <Form.Item>
                      {selectJL == '0' ?
                        <Row className={styles.hbCol}>
                          <Col span={14}>
                            {/* 成分含量 */}
                            <Form.Item
                              name='components'
                            >
                              <Input
                                size='middle'
                                allowClear
                                disabled />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            {/* 成分含量单位 */}
                            <Form.Item
                              name='componentsUnit'
                            >
                              <RecipeItemFieldInput
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={true}
                                noSize={true}
                              />
                            </Form.Item>
                          </Col>
                        </Row> :
                        <Row className={styles.hbCol}>
                          <Col span={6}>
                            {/* 容量 */}
                            <Form.Item
                              name='capacity'
                            >
                              <Input
                                size='middle'
                                allowClear
                                disabled />
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            {/* 容量单位 */}
                            <Form.Item
                              name='capacityUnit'
                            >
                              <RecipeItemFieldInput
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={true}
                                noSize={true}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={2} className={styles.flexCenter}> : </Col>
                          <Col span={6}>
                            {/* 成分含量 */}
                            <Form.Item
                              name='components'
                            >
                              <Input
                                size='middle'
                                allowClear
                                disabled />
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            {/* 成分含量单位 */}
                            <Form.Item
                              name='componentsUnit'
                            >
                              <RecipeItemFieldInput
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={true}
                                noSize={true}
                              />
                            </Form.Item>
                          </Col>
                        </Row>}
                    </Form.Item>
                  </Col> : <></>}
                <Col span={8} className={styles.hbCol} style={{ position: 'relative' }}>
                  <div className={styles.unitIcon}> * </div>
                  <Form.Item
                    label='最小包装数量 ｜ 单位'
                  >
                    <Row>
                      <Col span={14}>
                        {/* 最小包装数量 */}
                        <Form.Item
                          {...firstColumnLayout}
                          name='minPackNums'
                        >
                          <Input
                            size='middle'
                            allowClear
                            disabled
                            onChange={(e: any) => {
                              return
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* 最小包装单位 */}
                        <Form.Item
                          name='minPackUnit'
                        >
                          <RecipeItemFieldInput
                            placeholderInput='单位'
                            clearDataFlag={false}
                            field={'doseUnit'}
                            disabled={true}
                            noSize={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Row style={{ position: 'relative' }}>
                    <div className={styles.unitIconCHU}> / </div>
                    <Col span={14}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='accountUnit'
                        label='包装单位' //对应老的账簿单位
                      >
                        <RecipeItemFieldInput
                          clearDataFlag={false}
                          field={'accountUnit'}
                          disabled={true}
                          noSize={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={10} className={styles.bzdwTips}>查看示例</Col>
                  </Row>
                </Col>
                {ZYCYPshow ? <Col span={8}></Col> : <></>}
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='barCode'
                    label='条形码'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={16} style={{ position: 'relative' }}>
                  <Form.Item
                    label='商品标识码(追溯码前7位)'
                    {...firstColumnLayout}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={5}>
                        <Form.Item name='noTraceCodeFlag'>
                          <Select placeholder='' disabled>
                            <Option value={'0'} key={'0'}>
                              有码
                            </Option>
                            <Option value={'1'} key={'1'}>
                              无码
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={18} className={styles.addonAfterButton} style={{ position: 'relative' }}>
                        <Form.Item
                          name='drugMarkCode'
                          rules={[
                            {
                              pattern: new RegExp(/^[a-zA-Z0-9,]*$/, 'g'),
                              message: '请输入数字或字母',
                            },
                          ]}>
                          <Input
                            disabled
                            size='middle'
                            allowClear
                            style={{ width: '112%' }}
                          /></Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                  <Popover
                    title='药品标识码'
                    content={
                      <div>
                        <p>
                          药品标志码为药品追溯码的前一部分代码，当您维护此编码后，系统会在上传追溯码时为您校验
                          <span style={{ fontWeight: 'bold' }}>
                            是否扫错码
                          </span>
                          。
                        </p>
                        <p>一般情况下</p>
                        <p>
                          追溯码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            20位
                          </span>
                          的药品，药品标志码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            前7位
                          </span>
                        </p>
                        <p>
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            超过20位
                          </span>
                          的长追溯码（部分进口药），药品标志码为
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            前14位
                          </span>
                        </p>
                        <p>
                          如果同个品种存在多个标识码，可以用英文逗号隔开。您可以不用手动填写此代码，<span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            系统将在你扫码时自动更新该信息。
                          </span>
                        </p>
                        <p>
                          <img
                            src={DrugImg}
                            style={{ width: '300px' }}
                            alt=''
                          />
                        </p>
                        <p>有码无码：如果药品包装上无追溯码，可将该药品标记为“无码药品”，发药、入库时无需扫码采集。医保监管要求应采尽采，药品有追溯码但设置成无码，可能会存在监管处罚风险。</p>
                      </div>
                    }
                    placement='bottom'
                  >
                    <span className={styles.tips}>示例</span>
                  </Popover>
                </Col>
                {/* 中药材/饮片展示复方标志 */}
                {ZYCYPshow ? (
                  <>
                    <Col span={8}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='compoundTag'
                        label='复方标志'
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          placeholder='复方标志'
                          allowClear={false}
                          disabled
                        >
                          <Option value={0}>非草药</Option>
                          <Option value={1}>单味</Option>
                          <Option value={2}>复方</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
                {/* 中药材/饮片不展示展示OTC分类 */}
                {!ZYCYPshow ? (
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='otc'
                      label='OTC分类'
                    >
                      <Select
                        placeholder=''
                        allowClear={false}
                        disabled
                      >
                        {OtcCategories.map((v) => {
                          return (
                            <Option value={v} key={v}>
                              {getOtcCategoryName(v)}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )}
                <Col span={8}>
                  <Form.Item name='count' label='库存数量'>
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
              </Row> :
              <Row>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='no'
                    label='商品编码'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='name'
                    label='物资名称'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label='类别'
                    {...firstColumnLayout}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={9}>
                        <Form.Item name='materialsCategory' >
                          <Select placeholder='' allowClear disabled>
                            {Materiales.map((v) => (
                              <Option value={v} key={v}>
                                {getMaterialsName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={15}>
                        <Form.Item name='drugCategory'>
                          <Select
                            disabled
                          >
                            {YPdata.map((s) => (
                              <Select.Option key={s.name} value={s.name}>
                                {s.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='billingCategory'
                    label='开票项目'
                  >
                    <Select
                      placeholder=''
                      allowClear={false}
                      disabled
                    >
                      {InvoiceBillingCategories.map((v) => {
                        return (
                          <Option value={v} key={v}>
                            {BillingCategoryName(v)}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='approvalNumber'
                    label='批准文号'
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='model' label='型号'>
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='tenantSupplierName'
                    label='生产厂家'
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                {materialsCategory === '4' ?
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='barCode'
                      label='条形码'
                    >
                      <Input size='middle' allowClear disabled />
                    </Form.Item>
                  </Col> :
                  <Col span={8}>
                    <Form.Item name='lstdLicHolder' label='上市许可持有人'>
                      <Input size='middle' allowClear disabled />
                    </Form.Item>
                  </Col>
                }
                <Col span={8}></Col>
                <Col span={8}>
                  <Form.Item
                    name='spec'
                    label='规格'
                  >
                    <Input size='middle' allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={8} className={styles.hbCol} style={{ position: 'relative' }}>
                  <div className={styles.unitIcon}> * </div>
                  <Form.Item
                    label='最小包装数量 ｜ 单位'
                  >
                    <Row>
                      <Col span={14}>
                        {/* 最小包装数量 */}
                        <Form.Item
                          {...firstColumnLayout}
                          name='minPackNums'
                        >
                          <Input
                            size='middle'
                            allowClear
                            disabled
                            onChange={(e: any) => {
                              return
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* 最小包装单位 */}
                        <Form.Item
                          name='minPackUnit'
                        >
                          <RecipeItemFieldInput
                            placeholderInput='单位'
                            clearDataFlag={false}
                            field={'doseUnit'}
                            disabled={true}
                            noSize={true}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Row style={{ position: 'relative' }}>
                    <div className={styles.unitIconCHU}> / </div>
                    <Col span={14}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='accountUnit'
                        label='包装单位' //对应老的账簿单位
                      >
                        <RecipeItemFieldInput
                          clearDataFlag={false}
                          field={'accountUnit'}
                          disabled={true}
                          noSize={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={10} className={styles.bzdwTips}>查看示例</Col>
                  </Row>
                </Col>
                {materialsCategory === '4' ? <></> : <>
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='barCode'
                      label='条形码'
                    >
                      <Input size='middle' allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col span={16} style={{ position: 'relative' }}>
                    <Form.Item
                      label='商品标识码(追溯码前7位)'
                      {...firstColumnLayout}
                    >
                      <Row className={styles.hbCol}>
                        <Col span={5}>
                          <Form.Item name='noTraceCodeFlag'>
                            <Select placeholder='' disabled>
                              <Option value={'0'} key={'0'}>
                                有码
                              </Option>
                              <Option value={'1'} key={'1'}>
                                无码
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={18} className={styles.addonAfterButton} style={{ position: 'relative' }}>
                          <Form.Item
                            name='drugMarkCode'
                            rules={[
                              {
                                pattern: new RegExp(/^[a-zA-Z0-9,]*$/, 'g'),
                                message: '请输入数字或字母',
                              },
                            ]}>
                            <Input
                              disabled
                              size='middle'
                              allowClear
                              style={{ width: '112%' }}
                            /></Form.Item>
                        </Col>
                      </Row>
                    </Form.Item>
                    <Popover
                      title='药品标识码'
                      content={
                        <div>
                          <p>
                            药品标志码为药品追溯码的前一部分代码，当您维护此编码后，系统会在上传追溯码时为您校验
                            <span style={{ fontWeight: 'bold' }}>
                              是否扫错码
                            </span>
                            。
                          </p>
                          <p>一般情况下</p>
                          <p>
                            追溯码为
                            <span
                              style={{ color: '#068b39', fontWeight: 'bold' }}
                            >
                              20位
                            </span>
                            的药品，药品标志码为
                            <span
                              style={{ color: '#068b39', fontWeight: 'bold' }}
                            >
                              前7位
                            </span>
                          </p>
                          <p>
                            <span
                              style={{ color: '#d33f0e', fontWeight: 'bold' }}
                            >
                              超过20位
                            </span>
                            的长追溯码（部分进口药），药品标志码为
                            <span
                              style={{ color: '#d33f0e', fontWeight: 'bold' }}
                            >
                              前14位
                            </span>
                          </p>
                          <p>
                            如果同个品种存在多个标识码，可以用英文逗号隔开。您可以不用手动填写此代码，<span
                              style={{ color: '#068b39', fontWeight: 'bold' }}
                            >
                              系统将在你扫码时自动更新该信息。
                            </span>
                          </p>
                          <p>
                            <img
                              src={DrugImg}
                              style={{ width: '300px' }}
                              alt=''
                            />
                          </p>
                          <p>有码无码：如果药品包装上无追溯码，可将该药品标记为“无码药品”，发药、入库时无需扫码采集。医保监管要求应采尽采，药品有追溯码但设置成无码，可能会存在监管处罚风险。</p>
                        </div>
                      }
                      placement='bottom'
                    >
                      <span className={styles.tips}>示例</span>
                    </Popover>
                  </Col></>}

              </Row>}
            <div className={styles.titleText}> 可编辑</div>
            <Row>
              <Col span={8}>
                <Form.Item
                  name='productDate'
                  label='生产日期'
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(
                        /(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})\/(((0[13578]|1[02])\/(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)\/(0[1-9]|[12][0-9]|30))|(02\/(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))\/02\/29)/
                      ),
                      message: '请输入正确时间,时间格式为YYYY/mm/DD',
                    },
                  ]}
                >
                  <Input size='middle' allowClear />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name='deadline'
                  label='有效期至'
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(
                        /(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})\/(((0[13578]|1[02])\/(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)\/(0[1-9]|[12][0-9]|30))|(02\/(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))\/02\/29)/
                      ),
                      message: '请输入正确时间,时间格式为YYYY/mm/DD',
                    },
                  ]}
                >
                  <Input size='middle' allowClear />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name='shelfNo' label='货架号' >
                  <Input size='middle' allowClear />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          {/* 右侧内容 */}
          {/* 校医务室药品不展示 */}
          {tenantCategory == 17 ? <></> :
            <>
              <Col span={9} className={styles.rightContent}>
                <Row className={styles.rightContentTitle}>
                  <Col span={6} className={styles.titleText}>价格信息</Col>
                </Row>
                <Row>
                  <Col span={12} style={{ position: 'relative' }}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='retailPrice'
                      label='售价/元'
                    >
                      <Input size='middle' allowClear disabled />
                    </Form.Item>
                  </Col>
                  {/* 勾选了允许拆零才显示拆零售价 */}
                  {splitTag ?
                    <Col span={12}>
                      <Form.Item
                        name='splitPrice'
                        label='拆零售价/元'
                      >
                        <Input size='middle' allowClear disabled />
                      </Form.Item>
                    </Col> : <></>}
                  <Col span={12}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='stockPrice'
                      label='进价/元'
                    >
                      <Input size='middle' allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ position: 'relative' }}>
                    <Form.Item
                      name='tax'
                      {...firstColumnLayout}
                      label='项目税率'
                    >
                      <Input size='middle' disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </>}
        </Row>
      </Form>

      <div className={styles.bottomContent} style={{ position: 'relative' }}>
        <Button
          style={{ marginRight: '10px' }}
          onClick={(() => {
            history.go(-1)
            dispatch(setDetail({}))
          })}
        >
          返回
        </Button>
        <Button
          type="primary"
          loading={isSubmitLoading}
          style={{ marginRight: '10px' }}
          onClick={(() => {
            form.submit()
          })}>
          完成
        </Button>
      </div>
    </div>
  )
}
